/**
 * modal.js — dialog モーダル制御
 *
 * - data-modal-open 属性のボタンでモーダルを開く
 * - data-modal-close 属性のボタン/リンクでモーダルを閉じる
 * - Escape キーで閉じる（cancel イベントを intercept してアニメーション対応）
 * - バックドロップクリックで閉じる
 * - フォーカス管理: 閉じた後にトリガーへフォーカスを戻す
 * - トランジション終了を待ってから close()
 */
export function initializeModal() {
  const openTriggers = document.querySelectorAll("[data-modal-open]");

  if (openTriggers.length === 0) return;

  openTriggers.forEach(function (trigger) {
    const targetId = trigger.getAttribute("data-modal-open");
    const dialog = document.getElementById(targetId);

    if (!dialog || dialog.tagName !== "DIALOG") return;

    let triggerElement = null;
    let isTransitioning = false;

    // ---- Open ----
    trigger.addEventListener("click", function () {
      if (isTransitioning || dialog.open) return;

      triggerElement = trigger;
      isTransitioning = true;
      dialog.showModal();

      requestAnimationFrame(function () {
        dialog.setAttribute("data-active", "true");
        isTransitioning = false;
      });
    });

    // ---- Close with transition ----
    function closeModal() {
      if (isTransitioning || !dialog.open) return;

      isTransitioning = true;
      dialog.setAttribute("data-active", "false");

      function handleTransitionEnd(e) {
        if (e.target !== dialog) return;
        dialog.removeEventListener("transitionend", handleTransitionEnd);
        finishClose();
      }

      dialog.addEventListener("transitionend", handleTransitionEnd);

      // Fallback: transition が発火しなかった場合
      setTimeout(function () {
        if (dialog.open && isTransitioning) {
          dialog.removeEventListener("transitionend", handleTransitionEnd);
          finishClose();
        }
      }, 600);
    }

    function finishClose() {
      dialog.close();
      isTransitioning = false;

      if (triggerElement) {
        triggerElement.focus();
        triggerElement = null;
      }
    }

    // ---- Close triggers ----
    const closeTriggers = dialog.querySelectorAll("[data-modal-close]");
    closeTriggers.forEach(function (closeBtn) {
      closeBtn.addEventListener("click", function () {
        closeModal();
      });
    });

    // ---- Backdrop click ----
    dialog.addEventListener("click", function (e) {
      if (e.target === dialog) {
        closeModal();
      }
    });

    // ---- Escape key (override native for transition) ----
    dialog.addEventListener("cancel", function (e) {
      e.preventDefault();
      closeModal();
    });

    // ---- Breakpoint: auto-close on resize to PC ----
    const breakpoint = window.matchMedia("screen and (min-width: 1024px)");
    breakpoint.addEventListener("change", function (e) {
      if (e.matches && dialog.open) {
        dialog.setAttribute("data-active", "false");
        dialog.close();
        isTransitioning = false;
      }
    });
  });
}
